
<template>
  <div class="q-ml-md">
    <div class="row">
      <div class="row col-12">
        <div>
          <p
            class="row col-12 items-center justify-between text-h6 text-weight-bold text-brand-5 items-center texto-titulo"
          >
            Relatório Status Troca
            <Modal
              :tipoSelecao="'single'"
              @unidade="getStatusTroca"
              :loadingValue="loadingValue"
              :dataDisable="true"
              :regra="true"
              :statusRetirada="true"
              :turno="true"
            />
          </p>
        </div>
      </div>
    </div>
    <flexmonster
      :exibir="exibir"
      :link="link"
      :columns="slice"
      :slice="slice"
      :types="types"
      :grid="layout"
      :updateLink="updateLink"
      :showTotals="showTotals"
      :showGrandTotals="showGrandTotals"
      :filtros="filtros"
      :exportName="'Relatório_Status_Troca'"
      :gerarCsv="gerarCsv"
      :url="url"
      :urlEp="urlEp"
      :formats="formats"
      :dadosRelatorioSalvo="dados"
      :salvarType="'statustroca'"
      @flexmonsterLoading="loadingStop"
      @enviarRespostaEp="getRelatorioSalvo"
    />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import Modal from "../components/Modal.vue";
import Flexmonster from "../components/Flexmonster.vue";
import { transformCsvAndSetLink } from "../../../utils/csvHelper.js";
export default {
  components: { Flexmonster, Modal },
  setup() {
    const store = useStore();
    const route = useRoute();

    const slice = ref({
      columns: "",
      rows: "",
      reportFilters: "",
      measures: "",
    });
    const link = ref("");
    const layout = ref("flat");
    const loadingValue = ref("");
    const types = ref({
      nome: {
        type: "string",
      },
      sap: {
        type: "string",
      },
      dias_em_atraso: {
        type: "number",
      },
      dias_para_retirada: {
        type: "number",
      },
      
      quantidade_total_regra: {
        type: "number",
      },
      quantidade_retirada: {
        type: "number",
      },
    });
    const updateLink = ref(0);
    const exibir = ref(false);
    const id = route.params.id;
    const filtros = ref("");
    const showTotals = ref("");
    const formats = ref([
      {
        name: "",
        thousandsSeparator: "",
        decimalPlace: "-1",
      },
    ]);
    const url = ref("");
    const gerarCsv = ref(false);
    const urlEp = ref("");
    const dados = ref({});
    const showGrandTotals = ref("");
    const relatorioLink = localStorage.getItem("relatorioLink");
    const targetColumns = [
      "dias_em_atraso",
      "dias_para_retirada",
      
      "quantidade_total_regra",
      "quantidade_retirada",
    ];

    const getStatusTroca = async (data, singleValue) => {
      console.log(singleValue);
      try {
        let filtrosObject = {
          unidade: singleValue?.label,
        };

        if (singleValue?.statusRetirada) {
          filtrosObject.statusRetirada = singleValue.statusRetirada;
        }

        if (singleValue?.turnos && singleValue.turnos.length > 0) {
          filtrosObject.turnos = singleValue.turnos;
        }

        loadingValue.value = true;
        const response = await store.dispatch("rel/getStatusTroca", {
          vendor_id: singleValue.id,
          regra_critica: singleValue.regraCritica,
          status: singleValue.statusRetirada,
          turno_ids:
            singleValue.turnos && singleValue.turnos.length > 0
              ? singleValue.turnos.join(",")
              : undefined,
        });

        link.value = await transformCsvAndSetLink(
          response.data.result.url,
          targetColumns
        );
        updateLink.value++;
        loadingValue.value = false;
        filtros.value = JSON.stringify(filtrosObject);
        exibir.value = true;
        url.value = response?.request?.responseURL;
      } catch (error) {
        console.log(error);
      }
    };

    const verificarUrl = async () => {
      if (
        id != "carregado" &&
        id != undefined &&
        id != "" &&
        id != "carregadoLink"
      ) {
        try {
          const response = await store.dispatch("rel/listarRelatoriosSalvos", {
            id,
          });
          let value = response.data.resultado.dados.map((e) => {
            e.template = JSON.parse(e.template);
            return e;
          });
          dados.value = value[0];
          urlEp.value = dados.value.url;
          url.value = dados.value.url;
          gerarCsv.value = true;
        } catch (error) {
          console.log(error);
        }
        return;
      }
      if (id == "carregado" && store.state.rel.relatorioCarregado != null) {
        dados.value = store.state.rel.relatorioCarregado;
        console.log(dados.value);
        layout.value = dados.value.layout;
        showTotals.value = dados.value.showTotals;
        showGrandTotals.value = dados.value?.showGrandTotals;

        slice.value.columns = dados.value.columns;
        slice.value.rows = dados.value.rows;
        slice.value.reportFilters = dados.value.filtros;
        slice.value.measures = dados.value.values;

        if (store.state.rel.aguardandoFiltros) {
          store.commit("rel/SET_AGUARDANDO_FILTROS", false);
          return;
        }

        slice.value?.rows.forEach((e) => {
          e.type = "number";
        });

        const response = await store.dispatch("rel/getCarregado", {
          url: dados.value.url.replace(
            /(?<=\/\/)[^.]+/,
            store.state.autenticacao.cliente[0]
          ),
        });

        link.value = await transformCsvAndSetLink(
          response.data.return.url,
          targetColumns
        );
        updateLink.value++;
        loadingValue.value = false;
        url.value = response?.request?.responseURL;
        exibir.value = true;

        return;
      }

      if (
        id == "carregadoLink" &&
        relatorioLink != null &&
        relatorioLink != undefined
      ) {
        exibir.value = true;
        link.value = relatorioLink;
        updateLink.value++;
        url.value = relatorioLink;
        return;
      }
    };

    const getRelatorioSalvo = async (response) => {
      loadingValue.value = true;

      filtros.value = dados.value.filtros;
      layout.value = dados.value.template.layout;
      showTotals.value = dados.value.template.showTotals;
      showGrandTotals.value = dados.value.template?.showGrandTotals;
      link.value = await transformCsvAndSetLink(
        response.return.url,
        targetColumns
      );

      slice.value.columns = dados.value.template.columns;
      slice.value.rows = dados.value.template.rows;
      slice.value.reportFilters = dados.value.template.filtros;
      slice.value.measures = dados.value.template.values;
      exibir.value = true;

      slice.value?.rows.forEach((e) => {
        e.type = "number";
      });
      loadingValue.value = false;
    };

    const loadingStop = async (value) => {
      loadingValue.value = value;
    };

    onMounted(() => {
      verificarUrl();
    });

    return {
      getStatusTroca,
      slice,
      layout,
      types,
      link,
      updateLink,
      loadingValue,
      exibir,
      getRelatorioSalvo,
      id,
      filtros,
      showTotals,
      formats,
      loadingStop,
      verificarUrl,
      url,
      urlEp,
      gerarCsv,
      dados,
      showGrandTotals,
    };
  },
};
</script>
